import { useMemo } from "react";

// hooks and utilities
import useFleet from "hooks/useFleet";
import useColors from "hooks/useColors";
import useModelData from "hooks/useModelData";
import { useTranslateFunction } from "lang/Translate";
import { routerOptions, useRedirectNew } from "hooks/useRedirect";

//components
import SideWindowTab from "../SideWindowTab";

// styles
import "./AircraftTab.scoped.scss";

function AircraftTab({ airportId }) {
	const fleet = useFleet();
	const aircraftToDisplay = useMemo(() => fleet.filter(a => a.location === airportId), [fleet, airportId]);
	const translate = useTranslateFunction("SideWindow->AirportPopup");

	return (
		<SideWindowTab text={translate("AIRCRAFT")} Icon={<i className="fa-solid fa-plane" />}>
			{aircraftToDisplay.length === 0 && <p>{translate("NO_AIRCRAFT")}</p>}
			{aircraftToDisplay.map(a => (
				<AircraftTabItem aircraft={a} key={a.ident} />
			))}
		</SideWindowTab>
	);
}

function AircraftTabItem({ aircraft }) {
	const [color] = useColors(aircraft.ident);
	const modelData = useModelData()(aircraft.id);
	const redirect = useRedirectNew(routerOptions.get("s"));

	return (
		<div className="card" onClick={() => redirect(`aircraft~${aircraft.ident}`)}>
			<div className={`indicator ${color}`} />
			<div className="name">{modelData.short_name}</div>
			<div className="reg">{aircraft.registration}</div>
		</div>
	);
}

export default AircraftTab;
